<template>
    <div>
        <v-container>
            <v-row class="mt-1 mb-3">
              <div class="subtitle-2">アサイン中の依頼 / Assigned Requests <br> (*NOTE：全員が辞退した場合は黄色になります。Field turns YELLOW if all the researchers declined the ticket）</div>  
            </v-row>
            <v-row no-gutters align="center" justify="center">
                <v-col cols="4" class="">
                    <v-text-field
                        label="チケット番号で検索"
                        solo
                        append-outer-icon="mdi-magnify"
                        v-model="searchTicketNumber"
                        clear-icon="mdi-close-circle"
                        clearable
                        @click:append-outer="searchClicked()"
                        @click:clear="clearSearchResults()"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col>
                    <!-- search result -->
                    <h5 v-if="searchResult" class="my-3">Search Result:</h5>
                    <v-row v-if="feedback" class="red--text mb-10">{{feedback}}</v-row>
                    <v-card v-if="searchResult" class="caption mb-2" hover>
                        <v-container>
                            <v-row no-gutters align="center" justify="center" style="min-height: 80px">
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{searchResult.ticket_number}}
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            <commentDialog :ticket="searchResult"></commentDialog>
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            <v-btn text x-small class="red--text" @click="deleteAssignments(searchResult.ticket_number)">削除</v-btn>
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="3" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{searchResult.ticket_subject}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{formatDate(searchResult.assign_time)}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{searchResult.deadline}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            クレジット：{{searchResult.price}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="3" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            Assigned to:
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            <span v-for="(researcher,index) in searchResult.researchers" :key="index">{{researcher}}:{{searchResult.researcherEmails[index]}} </span>
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="2" class="">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            Taken by:
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{searchResult.researchers[searchResult.researcherEmails.indexOf(searchResult.researcher_in_charge)]}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                    <v-divider v-if="searchResult" class="my-5"></v-divider>
                    <!-- first 15 results ordered by ticket number -->
                    <!-- <div>
                        {{assignedTicketsColor}}
                    </div> -->
                    <v-card v-for="(ticket,index) in assignedTicketsColor" :key="index" class="caption mb-2" hover :color="ticket.color">
                        <v-container>
                            <v-row no-gutters align="center" justify="center" style="min-height: 80px">
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{ticket.ticketDetails.ticket_number}}
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            <commentDialog :ticket="ticket.ticketDetails"></commentDialog>
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            <v-btn text x-small class="red--text" @click="deleteAssignments(ticket.ticketDetails.ticket_number)">削除</v-btn>
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="3" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{ticket.ticketDetails.ticket_subject}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            Assign Time @ {{formatDate(ticket.ticketDetails.assign_time)}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            締め切り：{{ticket.ticketDetails.deadline}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            クレジット：{{ticket.ticketDetails.price}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="3" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            Assigned to:
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            <span v-for="(researcher,index) in ticket.ticketDetails.researchers" :key="index">{{researcher}}:{{ticket.ticketDetails.researcherEmails[index]}} </span>
                                        </v-row>
                                        <!-- <v-row align="center" justify="center" class="pa-1">
                                            <span v-for="researcherEmail in ticket.ticketDetails.researcherEmails" :key="researcherEmail">{{researcherEmail}}; </span>
                                        </v-row> -->
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="2" class="">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            Taken by:
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{ticket.ticketDetails.researchers[ticket.ticketDetails.researcherEmails.indexOf(ticket.ticketDetails.researcher_in_charge)]}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <span class="caption">＊最新の依頼が15件まで表示されます。非表示の場合は、チケットNo.で検索してください。</span>
            </v-row>
            <v-row>
                <span class="caption">*Display 15 latest requests maximum and you can search by ticket No.</span>
            </v-row>
        </v-container>
    </div>
</template>

<script>
/* eslint-disable no-console */
import commentDialog from '@/components/dialogs/comment_dialog'
import {db} from '@/fb'

export default {
    name:'assignedPanel',
    props:['assignPanelKey'],
    data(){
        return{
            assignedTickets:[],
            lastVisibleTicket:null,
            searchTicketNumber:null,
            searchResult:null,

            feedback:null,
        }
    },
    components:{
        commentDialog,
    },
    computed:{
        assignedTicketsColor(){
            var assignedTicketsColor = this.assignedTickets.map(ticket=>{
                if(ticket.researchers.length!=0){
                    return {ticketDetails:ticket, color:'white'}
                }else{
                    return {ticketDetails:ticket, color:'primary'}
                }
                
            })
            return assignedTicketsColor
        },
        
    },
    methods:{
        formatDate(dateNow){
            let date = new Date(dateNow);
            return String(date.getFullYear())+'-'+String(date.getMonth()+1)+'-'+String(date.getDate())+' '+String(date.getHours())+':'+String(date.getMinutes())
        },
        searchClicked(){
            let ref_search = db.collection('ticket_assigned').where('ticket_number','==',parseInt(this.searchTicketNumber))
            ref_search.get().then(snap=>{
                if(snap.empty){
                    this.feedback = 'Ticket does not exist..'
                }
                else{
                    this.feedback = null;
                    snap.forEach(doc=>{
                        this.searchResult = doc.data()
                    })
                }
                
            })
        },
        clearSearchResults(){
            this.$emit('update-assign-panel',this.assignPanelKey+1)
        },
        deleteAssignments(ticket_number){
            if(confirm("本当に削除しますか？")){
               db.collection('ticket_assigned').doc(ticket_number.toString()).delete().then(()=>{
                    alert("削除しました！一回ページを更新してください")
                })
                .catch(err=>{
                    console.log(err);
                })
            }else{
                alert("キャンセルしました！")
            }
        }
    },
    created(){
        let ref = db.collection('ticket_assigned').orderBy('ticket_number','desc').limit(50)
        ref.get().then(snap=>{
            this.lastVisibleTicket = snap.docs[snap.docs.length-1]
            snap.forEach(doc=>{
                this.assignedTickets.push(doc.data())
            })
        })
    }
}
</script>

<style>
  .right-border {
    border-right: 1px solid #ffee00
  }
</style>